import React from 'react';
import { bg } from 'utils/importFile';
interface BackgroundProps {
  children: React.ReactNode;
}
const Background = ({ children }: BackgroundProps) => (
  <div className='min-h-screen bg-cover bg-center backdrop-blur-md' style={{ backgroundImage: `url(${bg})` }}>
    <div className='backdrop-blur-[5px] min-h-screen w-full flex items-center justify-center overflow-auto '>
      {children}
    </div>
  </div>
);

export default Background;
